import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * HKID generator following Single Responsibility Principle
 */
export class HkidGenerator extends BaseGenerator {
  generate(options = {}) {
    const { doublePrefix = false } = options;
    
    let prefix;
    if (doublePrefix) {
      prefix = this.randomLetter() + this.randomLetter();
    } else {
      prefix = this.randomLetter();
    }

    const digits = this.randomDigits(6);
    const partial = prefix + digits;
    const checksum = ChecksumCalculator.calculateHkidChecksum(partial + '0');
    
    return partial + checksum;
  }
}